import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Donate() {
  const navigate = useNavigate();
  
  const tmStyle = {
    fontSize: '0.5em',
    verticalAlign: 'super'
  };
  
  return (
    <div className="legal-page">
      <h1>Support NeuLogic<span style={tmStyle}>™</span></h1>
      
      <section className="donate-intro">
        <h2>Support Independent Software</h2>
        <p>
          NeuLogic<span style={tmStyle}>™</span> applications are independently designed, developed, tested, and maintained. Every contribution supports the time and resources required to improve existing applications, maintain free tools, and continue building practical software.
        </p>
        <p>
          If a NeuLogic application has been useful to you, a voluntary contribution is a direct way to support the work behind it.
        </p>
      </section>
      
      <section className="donate-support">
        <h2>What Your Support Makes Possible</h2>
        <ul>
          <li><strong>Continued development:</strong> Improving existing applications and creating new ones</li>
          <li><strong>Thorough testing:</strong> Refining reliability, usability, and compatibility</li>
          <li><strong>Free software:</strong> Helping keep useful NeuLogic tools available at no cost</li>
        </ul>
        <p>
          Contributions are entirely optional and are not payments for software licenses, products, or services. To purchase a paid application, use its product page.
        </p>
      </section>

      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '48px 0 32px 0' }}>
		<a 
		  href="https://donate.stripe.com/5kQ14p4wx7vCc22f8Nebu0b"
		  className="card-btn productpage-btn-small donate-btn"
		  target="_blank"
		  rel="noopener noreferrer"
		>
		  Support NeuLogic™
		</a>
      </div>
      
      <section className="donate-contact">
        <h2>Get in Touch</h2>
        <p>
          For product questions, feedback, or collaboration inquiries, please email{' '}
          <a href="mailto:support@neulogic.tech">support@neulogic.tech</a>.
        </p>
      </section>
      
      <div className="productpage-actions productpage-actions-row" style={{justifyContent:'flex-start', marginTop:'80px'}}>
        <button className="card-btn productpage-btn-small" onClick={() => navigate('/')} type="button" style={{cursor:'pointer'}}>&larr; Home</button>
      </div>
    </div>
  );
}
